import { SelectOption } from '@/components/Form'
import { ConsultationSessionEnum } from './ConsultationSessionEnum'
const Type: any[] = [
  {
    label: 'Sit-in',
    value: ConsultationSessionEnum.SsessionType.SitIn
  },
  {
    label: ' Video Recording',
    value: ConsultationSessionEnum.SsessionType.VideoRecording
  }
]
const Status: SelectOption[] = [
  {
    value: ConsultationSessionEnum.ConsultationSessionStatus.Submitted,
    label: 'Submitted by Trainee'
  },
  {
    value: ConsultationSessionEnum.ConsultationSessionStatus.Endorsed,
    label: 'Endorsed'
  },
  {
    value: ConsultationSessionEnum.ConsultationSessionStatus.Reject,
    label: 'Rejected'
  }
]
export const ConsultationSessionOption = { Type, Status }
